import { GetPositionArgs, Position } from "../../../hooks/useRelativePosition";
import { Side } from "../types";
import { getPosition } from "./getPosition";

export function constrainSidePosition(
  position: Position | null,
  positionArgs: GetPositionArgs,
): { position: Position | null; side: Side } | null {
  if (!position) return null;
  const { contentRef, side } = positionArgs;
  if (side === "top" && position.top < 0) {
    const bottomPosition = getPosition({
      ...positionArgs,
      side: "bottom",
    });
    return { position: bottomPosition, side: "bottom" };
  }

  if (side === "bottom") {
    const viewportHeight = window.innerHeight;
    const contentHeight = contentRef.current?.offsetHeight || 0;
    if (position.top + contentHeight > viewportHeight) {
      const topPosition = getPosition({ ...positionArgs, side: "top" });
      return { position: topPosition, side: "top" };
    }
  }

  if (side === "left" && position.left < 0) {
    const rightPosition = getPosition({
      ...positionArgs,
      side: "right",
    });
    return { position: rightPosition, side: "right" };
  }

  if (side === "right") {
    const viewportWidth = window.innerWidth;
    const contentWidth = contentRef.current?.offsetWidth || 0;
    if (position.left + contentWidth > viewportWidth) {
      const leftPosition = getPosition({
        ...positionArgs,
        side: "left",
      });
      return { position: leftPosition, side: "left" };
    }
  }

  return { position, side };
}
